// extracted by mini-css-extract-plugin
export default {"expandedRowContent":"AffiliatesTable_expandedRowContent__yBlhI"};